<template>
  <transition name="modal">
    <div class="modal-mask">
      <div class="modal-wrapper" @click="$emit('closeModal')">
        <div class="row">
          <div class="col-xs-0 col-sm-0 col-md-1 col-lg-2"></div>
          <div class="col-xs-12 col-sm-12 col-md-10 col-lg-8">
            <div class="modal-container" @click.stop>

                <div class="modal-header row" style="justify-content: flex-end;">
                  <!-- <div class="col-6">
                    <button type="button" class="btn btn-sm btn-outline-primary" @click="$emit('newUserBack')">< Back</button>
                  </div> -->
                  <div class="col">
                    <button type="button" class="close" @click="$emit('closeModal')">
                        <span aria-hidden="true">&times;</span>
                    </button>
                  </div>
                </div>

                <div class="modal-body">
                  <h2 class="title">Add Calendar Event</h2>
                  <form>
                    <div class="row row-space">
                      <div class="col-xs-12 col-sm-6 col-md-6 col-lg-6">
                        <div class="input-group">
                          <label class="label">Date Range<span style="color: red;">*</span></label>
                          <div class="w-100">
                            <flat-pickr
                              v-model="selected.date"
                              :config="rangeConfig"
                              placeholder="Range Picker"
                              :disabled="dateSelected != null"
                            />
                          </div>
                        </div>
                      </div>
                      <div class="col-xs-12 col-sm-6 col-md-6 col-lg-6">
                        <div class="input-group" style="padding-bottom:0px">
                          <label class="label">Holiday<span style="color: red;">*</span></label>
                          <!-- <MultiSelect
                            v-model="form.holiday"
                            :options="options.holiday.map(x=>x.value)"
                            :custom-label="opt => options.holiday.find(x => x.value == opt).name"
                          ></MultiSelect> -->
                          
                        </div>
                        <div class="custom-control custom-radio ml-4 mt-1" v-for="(holiday , index) in options.holiday" :key="holiday.value">
                            <input type="radio" :id="'customRadioHoliday' + index" :name="'customRadioHoliday' + index" class="custom-control-input" :value="holiday.value" v-model="form.holiday">
                            <label class="custom-control-label" :for="'customRadioHoliday' + index">{{holiday.name}}</label>
                        </div>
                      </div>
                    </div>
                    <div class="row row-space">
                      <div class="col-md-6 offset-md-3">
                        <div class="input-group">
                          <label class="label" style="opacity: 0.7;">Note</label>
                          <input class="input--style-4" type="text" v-model="form.note">
                        </div>
                      </div>
                    </div>
                    <div class="row">
                      <div class="col mt-5" style="text-align: center">
                        <button type="button" class="btn btn-outline-danger" style="font-size:140%" @click="$emit('closeModal')">Cancel</button>
                        <button type="button" class="btn btn-primary ml-5" style="font-size:150%" @click="submitForm()">Add</button>
                      </div>
                    </div>
                  </form>
                </div>
            </div>
          </div>
        </div>
        <div class="col-xs-0 col-sm-0 col-md-1 col-lg-2"></div>
      </div>
    </div>
  </transition>
</template>
  
  <script>
    import MultiSelect from 'vue-multiselect';
    import flatPickr from 'vue-flatpickr-component'
  
    export default {
      data () {
        return{
          mobile : this.isMobile(),
          rangeConfig: {
            mode: 'range',
            altInput: true,
            altInputClass: 'form-control input flatpickr-input',
            animate: !isRTL()
          },
          options : {
            holiday : [{name:'Yes',value:1}, {name:'No', value:0}],
          },
          selected : {
            date : '',
          },
          form : {
            start : '',
            end : '',
            holiday : 1,
            note : ''
          },
        }
      },
      props : ['user_id' , 'dateSelected'],
      components:{
        MultiSelect,
        flatPickr,
      },
      mounted () {
        this.dateSelected ? this.selected.date = this.dateSelected : ''
      },
      watch : {
        'selected.date' () {
          if(this.selected.date.includes('to')) {
            let splitDateRange = this.selected.date.split(' to ');
            this.form.start = splitDateRange[0]
            this.form.end = splitDateRange[1]
          }
          else {
            this.form.start = this.selected.date
            this.form.end = this.selected.date
          }
          
        },
      },
      methods : {
        validateForm(){
          var valid = true;
          var error = [];

          if(this.form.start == '' || this.form.start == null || this.form.end == '' || this.form.end == null){//Start and End [Required]
            valid = false;
            error.push('Date is a required Field!');
          }
          console.log(this.form.holiday)

          if(!typeof this.form.holiday == 'number'){//Holiday [Required]
            valid = false;
            error.push('Holiday is a required Field!');
          }

          // if(this.form.note == '' || this.form.note == null){//Notes [Required]
          //   valid = false;
          //   error.push('Notes is a required Field!');
          // }

          // console.log(JSON.stringify(error));
          if(!valid) this.$emit('triggerAlert', !valid, error);
          else return valid;
        },
        async submitForm(){
          let vm = this;
          if(vm.validateForm()){
            this.$http.post('/api/setting/calendar', this.form)
            .then((resp)=>{
                // this.triggerAlert(true , ['Succesfully Saved Calendar Event'])
                this.$emit('onSuccess');
                this.$emit('closeModal');
              })
            .catch((err)=>{
              console.log(err);
              // vm.$emit('triggerAlert', true, ['An error has occured!']);
              // this.triggerAlert(false , [err])
            })
          }
        }
      }
    }

  function isRTL () {
    return document.documentElement.getAttribute('dir') === 'rtl' || document.body.getAttribute('dir') === 'rtl'
  }
  </script>
  
  <style scoped>
    .modal-mask {
        position: fixed;
        z-index: 1020;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        background-color: rgba(0, 0, 0, .5);
        display: table;
        transition: opacity .3s ease;
    }
  
    .modal-wrapper {
        display: table-cell;
        vertical-align: middle;
    }
  
    .modal-container {
        width: 100%;
        margin: 0px auto;
        padding: 20px 30px;
        background-color: #fff;
        border-radius: 8px;
        box-shadow: 0 2px 8px rgba(0, 0, 0, .33);
        transition: all .3s ease;
        font-family: Helvetica, Arial, sans-serif;
    }
  
    .modal-header h3 {
        margin-top: 0;
        color: #42b983;
    }
  
    .modal-body {
        margin: 20px 0;
    }
  
    .modal-default-button {
        float: right;
    }
  
    /*
    * The following styles are auto-applied to elements with
    * transition="modal" when their visibility is toggled
    * by Vue.js.
    *
    * You can easily play with the modal transition by editing
    * these styles.
    */
  
    .modal-enter {
        opacity: 0;
    }
  
    .modal-leave-active {
        opacity: 0;
    }
  
    .modal-enter .modal-container,
    .modal-leave-active .modal-container {
        -webkit-transform: scale(1.1);
        transform: scale(1.1);
    }
  
    /* MODAL STARTS */
    .modal-body{
        margin:0
    }
  
    .modal-body .moduleLine{
        margin-bottom: 0vh;
    }
  
    .modal-body .moduleLine a{
        text-decoration: none;
    }
  
    .modal-body .moduleLine .moduleBox:hover{
        background-color: #E0E0E0;
        transition: background-color 0.7s ease;
        color: #212121;
        transition: color 0.7s ease;
    }
  
    .modal-body .moduleLine .moduleBox{
        border:1px solid #BDBDBD;
        border-radius: 20px;
        padding: 20px 0;
        color:black;
        margin-bottom: 3vh;
    }
  
    .modal-body .moduleLine .moduleBox i{
        font-size:5vh;
    }
  
    h3.modalHeadline{
        margin:0 0 20px 0;
        font-weight: bold;
        text-align : center;
    }
    /* MODAL ENDS */
  
  /* ==========================================================================
  #FORM made by Colorlib (https://colorlib.com)
  ========================================================================== */
  input {
    outline: none;
    margin: 0;
    border: none;
    -webkit-box-shadow: none;
    -moz-box-shadow: none;
    box-shadow: none;
    width: 100%;
    font-size: 14px;
    font-family: inherit;
  }
  
  .input--style-4 {
    line-height: 50px;
    background: #fafafa;
    -webkit-box-shadow: inset 0px 1px 3px 0px rgba(0, 0, 0, 0.08);
    -moz-box-shadow: inset 0px 1px 3px 0px rgba(0, 0, 0, 0.08);
    box-shadow: inset 0px 1px 3px 0px rgba(0, 0, 0, 0.08);
    -webkit-border-radius: 5px;
    -moz-border-radius: 5px;
    border-radius: 5px;
    padding: 0 20px;
    font-size: 16px;
    color: #666;
    -webkit-transition: all 0.4s ease;
    -o-transition: all 0.4s ease;
    -moz-transition: all 0.4s ease;
    transition: all 0.4s ease;
  }
  
  .input--style-4::-webkit-input-placeholder {
    /* WebKit, Blink, Edge */
    color: #666;
  }
  
  .input--style-4:-moz-placeholder {
    /* Mozilla Firefox 4 to 18 */
    color: #666;
    opacity: 1;
  }
  
  .input--style-4::-moz-placeholder {
    /* Mozilla Firefox 19+ */
    color: #666;
    opacity: 1;
  }
  
  .input--style-4:-ms-input-placeholder {
    /* Internet Explorer 10-11 */
    color: #666;
  }
  
  .input--style-4:-ms-input-placeholder {
    /* Microsoft Edge */
    color: #666;
  }
  
  .label {
    font-size: 16px;
    color: #555;
    text-transform: capitalize;
    display: block;
    margin-bottom: 5px;
  }
  
  .radio-container {
    display: inline-block;
    position: relative;
    padding-left: 30px;
    cursor: pointer;
    font-size: 16px;
    color: #666;
    -webkit-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
    user-select: none;
  }
  
  .radio-container input {
    position: absolute;
    opacity: 0;
    cursor: pointer;
  }
  
  .radio-container input:checked ~ .checkmark {
    background-color: #e5e5e5;
  }
  
  .radio-container input:checked ~ .checkmark:after {
    display: block;
  }
  
  .radio-container .checkmark:after {
    top: 50%;
    left: 50%;
    -webkit-transform: translate(-50%, -50%);
    -moz-transform: translate(-50%, -50%);
    -ms-transform: translate(-50%, -50%);
    -o-transform: translate(-50%, -50%);
    transform: translate(-50%, -50%);
    width: 12px;
    height: 12px;
    -webkit-border-radius: 50%;
    -moz-border-radius: 50%;
    border-radius: 50%;
    background: #57b846;
  }
  
  .checkmark {
    position: absolute;
    top: 50%;
    -webkit-transform: translateY(-50%);
    -moz-transform: translateY(-50%);
    -ms-transform: translateY(-50%);
    -o-transform: translateY(-50%);
    transform: translateY(-50%);
    left: 0;
    height: 20px;
    width: 20px;
    background-color: #e5e5e5;
    -webkit-border-radius: 50%;
    -moz-border-radius: 50%;
    border-radius: 50%;
    -webkit-box-shadow: inset 0px 1px 3px 0px rgba(0, 0, 0, 0.08);
    -moz-box-shadow: inset 0px 1px 3px 0px rgba(0, 0, 0, 0.08);
    box-shadow: inset 0px 1px 3px 0px rgba(0, 0, 0, 0.08);
  }
  
  .checkmark:after {
    content: "";
    position: absolute;
    display: none;
  }
  
  .input-group {
    position: relative;
    /* margin-bottom: 22px; */
    padding:20px;
  }
  
  .input-group-icon {
    position: relative;
  }
  
  .input-icon {
    position: absolute;
    font-size: 18px;
    color: #999;
    right: 18px;
    top: 50%;
    -webkit-transform: translateY(-50%);
    -moz-transform: translateY(-50%);
    -ms-transform: translateY(-50%);
    -o-transform: translateY(-50%);
    transform: translateY(-50%);
    cursor: pointer;
  }
  
  /* ==========================================================================
     #TITLE made by Colorlib (https://colorlib.com)
     ========================================================================== */
  .title {
    font-size: 40px;
    color: #525252;
    margin-bottom: 40px;
    text-align: center;
  }
  
  
  .center{
    text-align: center;
  }
  .left{
    text-align: left;
  }
  .right{
    text-align: right;
  }
  
  .outerBox{
      padding: 0 20px;
  }
  .innerBox{
      border:1px solid #EEEEEE;
      border-radius:5px;
      background-color: white;
      padding:5vw;
      box-shadow: 0 8px 20px 0 rgba(0, 0, 0, 0.15)
  }
  .paddingInnerInnerBox{
    padding:10px 15px;
  }
  .outerBoxPass{
    padding: 20px;
  }
  .innerBoxPass{
    border:1px solid #BDBDBD;
    border-radius:5px;
    box-shadow: 10px 10px 20px #E0E0E0;
  }
  .paddingInnerInnerBox p{
    margin: 0;
  }
  .subPartTitle{
    font-size: 110%;
    padding: 6px 12px;
    color: #757575;
  }
  .collapsed:hover{
    text-decoration: underline;
  }
  .collapseButton{
    color: black;
  }
  </style>
  